export default "__VITE_ASSET__BIM$lE1l__"